module.exports = __webpack_public_path__ + "img/LKW.f3b029f1.svg";